import api from "../../api.js";

export const getReceiptDetails = (recieptno) => api.get(`/frontshop/receipt/${encodeURIComponent(recieptno)}`);
export const lookupReceipt = (recieptno) => api.get(`/frontshop/receipt/lookup/${encodeURIComponent(recieptno)}`);
export const getReceiptPrintData = (recieptno) => api.get(`/frontshop/receipt/print/${encodeURIComponent(recieptno)}`);
